module.exports = __webpack_public_path__ + "eb3aded4b336e659d03a4e3922a8b9b0.svg";